<template>
  <div class="common">
    <search-form :formConfig="formConfig" :source="searchData" @search="search" @handleSearch="handleSearch">
      <template slot="btns">
        <a-button type="primary" @click="handleAdd">新增</a-button>
      </template>
    </search-form>
    <div class="table-common">
      <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData"
        :pagination="pagination" :loading="loading" bordered :scroll="columns.length>10?{ x: '100%' }:{}"
        :locale="{emptyText: '暂无数据'}" @change="handleTableChange">
        <template slot="createTime" slot-scope="text">{{text | dateFormat('YYYY-mm-dd HH:MM')}}</template>
        <template slot="operation" slot-scope="text, record">
          <a-button type="link" @click="toPageDetail(record)">查看</a-button>
          <!-- <a-button type="link" @click="handleDownload(record.fileMap)">下载</a-button> -->
          <a-button type="link" @click="handleEdit(record)">修改</a-button>
        </template>
      </a-table>
    </div>
    <!-- <transferPdfView ref="transferPdfView"/> -->
    <AddPage ref="AddPage" @success="getTableData"></AddPage>
  </div>
</template>

<script>
import { contractList, updateMainContractFlag } from '@/api/contract.js'
import { selectSellerCst } from '@/api/rcvbBuy.js'
import AddPage from './AddPage.vue'
export default {
  components: {
    AddPage,
  },
  data() {
    return {
      loading: false,
      searchData: {
        contractNo: undefined,
        sellrOrgCode: undefined,
      },
      formConfig: [
        {
          prop: 'contractNo',
          type: 'input',
          label: '框架合同编号',
        },
        {
          prop: 'sellrOrgCode',
          type: 'selectSearch',
          label: '卖方名称',
          option: [],
          searchSource: true,
          headNameFirst: '卖方名称',
          headNameSecond: '社会信用代码',
          valuePorp: 'orgCode',
          labelPorp: 'userName',
          searchHandle: 'handleSearch',
        },
      ],
      columns: [
        {
          title: '框架合同编号',
          dataIndex: 'contractNo',
        },
        {
          title: '卖方名称',
          dataIndex: 'sellrName',
          ellipsis: true,
          sorter: true,
        },
        {
          title: '统一社会代码',
          dataIndex: 'sellrOrgCode',
          ellipsis: true,
        },
        {
          title: '创建时期',
          dataIndex: 'createTime',
          sorter: true,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: 'createTime',
        sortOrder: 'desc',
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        showTotal: (total) => {
          return `共 ${total} 条`
        },
      },
    }
  },
  methods: {
    search(data) {
      this.searchData = data || this.searchData
      this.getTableData()
    },
    // 卖方名称选项
    handleSearch(value, data) {
      selectSellerCst({
        pageSize: 10,
        effStCd: 1,
        statusCode: 0,
        state: 2,
        userName: value || '',
        pageNum: 1,
      })
        .then((res) => {
          this.formConfig.forEach((item, index) => {
            if (item.label == '卖方名称') {
              this.formConfig[index].option = res.data.grid.list
              // this.importOption = res.data.grid.list;
            }
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(sorter)
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.pagination.sortField = sorter.field || pagination.sortField;
      this.pagination.sortOrder = sorter.order || pagination.sortOrder;
      this.pagination.total = this.pagination.total || 0
      this.getTableData()
    },
    getTableData() {
      this.loading = true
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        contractNo: this.searchData.contractNo,
        sellrOrgCode: this.searchData.sellrOrgCode && this.searchData.sellrOrgCode.key,
        orderBy: this.pagination.sortField
          ? `${this.pagination.sortField == "sellrName" ? "sellrOrgCode" : this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
          }`
          : "",
      }
      contractList(params)
        .then((res) => {
          this.loading = false
          this.tableData = res.data.grid.list
          this.pagination.total = res.data.grid.total
        })
        .catch((err) => {
          this.loading = false
        })
    },
    handleAdd() {
      this.$nextTick(() => {
        this.$refs.AddPage.open()
      })
    },
    handleEdit(row) {
      updateMainContractFlag(row.id).then(res => {
        this.$nextTick(() => {
          this.$refs.AddPage.open(row)
        })
      })

    },
    handleDownload(item) {
      const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install'
      window.open(
        `${DOWNLOAD_PREFIX}${item.fileRte}/${item.fileNm || item.name}`,
        '_blank'
      )
    },
    toPageDetail(row) {
      this.$nextTick(() => {
        this.$refs.AddPage.open(row, true)
      })
    },
  },
  created() {
    this.getTableData()
  },
  mounted() { },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/contract/list.vue